export default "__VITE_ASSET__a3HnEJOL__"